// import * as React from "react";
// import AppBar from "@mui/material/AppBar";
// import Box from "@mui/material/Box";
// import Toolbar from "@mui/material/Toolbar";
// import Typography from "@mui/material/Typography";
// import Button from "@mui/material/Button";
// import IconButton from "@mui/material/IconButton";
// import MenuIcon from "@mui/icons-material/Menu";
// import Badge from "@mui/material/Badge";
// import NotificationsIcon from "@mui/icons-material/Notifications";
// import Sidebar from "./Sidebar";
// import StudentModal from "./StudentModal";
// import { useNavigate } from "react-router-dom";

// function Navbar({ onLogout }) {
//   const [state, setState] = React.useState({
//     top: false,
//     left: false,
//     bottom: false,
//     right: false,
//   });

//   const [openModal, setOpenModal] = React.useState(false);

//   const notifications = [
//     "This is the first notification. It might be longer than one line.",
//     "This is the second notification. Also might be long.",
//     "Another notification. This is the third one.",
//     "Fourth notification. It has some more content to show.",
//     "Fourth notification. It has some more content to show.",
//     "Fourth notification. It has some more content to show.",
//   ];

//   const toggleDrawer = (anchor, open) => (event) => {
//     if (
//       event.type === "keydown" &&
//       (event.key === "Tab" || event.key === "Shift")
//     ) {
//       return;
//     }
//     setState({ ...state, [anchor]: open });
//   };

//   const handleLogout = () => {
//     const logoutConfirmed = window.confirm("Are you sure you want to logout?");
//     if (logoutConfirmed) {
//       localStorage.removeItem("userRole");
//       localStorage.removeItem("userId");
//       localStorage.removeItem("loginId");

//       if (onLogout) {
//         onLogout();
//       }
//       window.location.href = "/login";
//     }
//   };

//   const handleOpenModal = () => {
//     setOpenModal(true);
//   };

//   const handleCloseModal = () => {
//     setOpenModal(false);
//   };

//   return (
//     <Box sx={{ flexGrow: 1 }}>
//       <AppBar position="static">
//         <Toolbar>
//           <IconButton
//             size="large"
//             edge="start"
//             color="inherit"
//             aria-label="menu"
//             sx={{ mr: 2 }}
//             onClick={toggleDrawer("left", true)}
//           >
//             <MenuIcon />
//           </IconButton>
//           <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
//             {/* Your App Name */}
//           </Typography>
//           <IconButton color="inherit" onClick={handleOpenModal}>
//             <Badge badgeContent={notifications.length} color="error">
//               <NotificationsIcon />
//             </Badge>
//           </IconButton>
//           <Button color="inherit" onClick={handleLogout}>
//             Logout
//           </Button>
//         </Toolbar>
//       </AppBar>
//       <Sidebar state={state} setState={setState} toggleDrawer={toggleDrawer} />
//       <StudentModal
//         open={openModal}
//         onClose={handleCloseModal}
//         notifications={notifications}
//       />
//     </Box>
//   );
// }

// export default Navbar;



import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Sidebar from "./Sidebar";
import { ApiUrl } from "../ApiUrl";
import { Select, MenuItem, FormControl, InputLabel, Grid } from "@mui/material";

const getNextAcademicYear = (years, selectedYear) => {
  const sortedYears = [...years].sort((a, b) => a.dateFrom - b.dateFrom);
  const currentYearIndex = sortedYears.findIndex(
    (year) => year.id === selectedYear.id
  );

  return currentYearIndex >= 0 ? sortedYears[currentYearIndex + 1] : null;
};

const persistAcademicSession = (selectedYear, years, onSessionChange) => {
  if (!selectedYear) {
    return;
  }

  localStorage.setItem("academicSessionId", selectedYear.id);
  localStorage.setItem("orgId", selectedYear.orgId || "");
  localStorage.setItem("branchId", selectedYear.branchId || "");
  localStorage.setItem(
    "dateFrom",
    selectedYear.dateFrom.toISOString().split("T")[0]
  );

  const nextYear = getNextAcademicYear(years, selectedYear);
  if (nextYear) {
    localStorage.setItem("nextAcademicSessionId", nextYear.id);
  } else {
    localStorage.removeItem("nextAcademicSessionId");
  }

  if (onSessionChange) {
    onSessionChange();
  }
};

function Navbar({ onLogout }) {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [academicSession, setAcademicSession] = React.useState("");
  const [academicYears, setAcademicYears] = React.useState([]);
  const [currentDateTime, setCurrentDateTime] = React.useState(""); // State for date and time
  
  React.useEffect(() => {
    const fetchAcademicYears = async () => {
      try {
        const studentId = sessionStorage.getItem("userId");
        const [academicYearResponse, studentProfileResponse] = await Promise.all([
          fetch(`${ApiUrl.apiurl}AcademicYear/GetAllAcademicYear/`),
          studentId
            ? fetch(`${ApiUrl.apiurl}STUDENT_PROFILE/GetStudentProfile/${studentId}/`)
            : Promise.resolve(null),
        ]);

        const data = await academicYearResponse.json();
        if (data.message === "Success") {
          const formattedYears = (data.data || [])
            .map((year) => ({
              id: year.id,
              code: year.sesion_code,
              orgId: year.org_id || null,
              branchId: year.branch_id || null,
              dateFrom: new Date(year.date_from),
              dateTo: new Date(year.date_to),
            }))
            .sort((a, b) => a.dateFrom - b.dateFrom);

          let studentProfile = null;
          if (studentProfileResponse?.ok) {
            const studentPayload = await studentProfileResponse.json();
            if (studentPayload?.message === "Success" && studentPayload?.data) {
              studentProfile = studentPayload.data;
            }
          }

          const studentAcademicYear = studentProfile?.academicyearId
            ? formattedYears.find(
                (year) =>
                  String(year.id) === String(studentProfile.academicyearId)
              )
            : null;

          const scopedYears = studentAcademicYear
            ? formattedYears.filter(
                (year) =>
                  year.orgId === studentAcademicYear.orgId &&
                  year.branchId === studentAcademicYear.branchId
              )
            : formattedYears;

          setAcademicYears(scopedYears);

          const storedSessionId = localStorage.getItem("academicSessionId");
          const forceAutoAcademicSession =
            sessionStorage.getItem("forceAutoAcademicSession") === "true";
          let currentYearData = null;


     

          if (studentAcademicYear) {
            currentYearData = scopedYears.find(
              (year) => year.id === studentAcademicYear.id
            );
          }

          if (!currentYearData && storedSessionId) {
            currentYearData = scopedYears.find(

              (year) => year.id.toString() === storedSessionId
            );
          }

          if (!currentYearData) {

            // Find current session based on date
            const currentDate = new Date();
            currentYearData = scopedYears.find((year) => {
              return currentDate >= year.dateFrom && currentDate <= year.dateTo;
            });
          }

          if (!currentYearData && scopedYears.length > 0) {
            currentYearData = scopedYears[scopedYears.length - 1];
          }

          if (currentYearData) {
            setAcademicSession(currentYearData.code);
            persistAcademicSession(
              currentYearData,
              scopedYears,
              () => window.dispatchEvent(new Event("academicSessionChanged"))
            );
          }

          if (forceAutoAcademicSession) {
            sessionStorage.removeItem("forceAutoAcademicSession");
          }
        }
      } catch (error) {
        console.error("Error fetching academic years:", error);
      }
    };

    fetchAcademicYears();
  }, []);

  React.useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const formattedDateTime = now.toLocaleString("en-US", {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
      });
      setCurrentDateTime(formattedDateTime);
    };
    updateTime(); // Set initial time
    const interval = setInterval(updateTime, 1000); // Update time every second
    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };
  const handleLogout = () => {
    const logoutConfirmed = window.confirm("Are you sure you want to logout?");
    if (logoutConfirmed) {
      sessionStorage.removeItem("userRole");
      sessionStorage.removeItem("userId");
      sessionStorage.removeItem("userTypeId");
      sessionStorage.removeItem("username");
      localStorage.clear();
      window.location.href = "/login";
    }
  };
  const handleSessionChange = (event) => {
    const selectedCode = event.target.value;
    setAcademicSession(selectedCode);
    const selectedYear = academicYears.find(
      (year) => year.code === selectedCode
    );
    if (selectedYear) {
      persistAcademicSession(
        selectedYear,
        academicYears,
        () => window.dispatchEvent(new Event("academicSessionChanged"))
      );
    }
  };
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <Grid container alignItems="center" justifyContent="space-between">
            {/* Sidebar toggle icon - Left */}
            <Grid item xs="auto">
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                disableRipple
                disableFocusRipple
                onClick={() => setState({ ...state, left: true })}
                sx={{
                  "&:hover": { backgroundColor: "transparent" }, // removes hover grey
                }}
              >
                <MenuIcon />
              </IconButton>
            </Grid>

            {/* Academic Session - Centered */}
            <Grid item xs={12} sm={6} md={4}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{ width: "100%" }}
              >
                <Typography variant="body1" sx={{ color: "#fff", mr: 1 }}>
                  Academic Session:
                </Typography>
                <FormControl size="small" sx={{ minWidth: 140 }}>
                  <InputLabel sx={{ color: "#fff" }}>Select Session</InputLabel>
                  <Select
                    value={academicSession}
                    onChange={handleSessionChange}
                    label="Select Session"
                    sx={{ color: "#fff" }}
                  >
                    {academicYears.map((year) => (
                      <MenuItem key={year.id} value={year.code}>
                        {year.code}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Grid>

            {/* Time & Logout - Right */}
            <Grid item xs="auto">
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  flexWrap: "wrap",
                }}
              >
                <Typography variant="body2" sx={{ color: "#fff" }}>
                  {currentDateTime}
                </Typography>
                <Button
                  color="inherit"
                  onClick={handleLogout}
                  sx={{
                    border: "1px solid white",
                    padding: "4px 12px",
                    fontSize: "0.875rem",
                  }}
                >
                  Logout
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <Sidebar state={state} setState={setState} toggleDrawer={toggleDrawer} />
    </Box>
  );
}
export default Navbar;
